export const formatContentForDisplay = (content: string): string => {
  if (!content) return '';

  // Function to convert URLs in text to clickable links
  const linkify = (text: string): string => {
    // This regex is more specific about what constitutes a URL character,
    // preventing it from consuming HTML tags or surrounding text.
    const urlRegex = /(https?:\/\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]+)/g;
    return text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`);
  };

  // First, linkify URLs in the raw content.
  // This ensures that the regex correctly identifies URLs based on natural text boundaries.
  let processedContent = linkify(content);

  // Then, convert newlines to <br /> tags.
  // This ensures that line breaks are rendered correctly after URLs have been processed,
  // and it won't interfere with the linkify logic.
  processedContent = processedContent.replace(/\n/g, '<br />');
  
  return processedContent;
};